import ApiService from "@/common/api/api.service";
import helpers from "@/common/utils/helpers";
import cloneDeep from "lodash/cloneDeep";

let endpoint = "Proposta";

const Investimento = {

    setEndpoint(endpointSelecionado) {
        endpoint = endpointSelecionado;
    },

    buscar(id, rubrica) {
        return ApiService.get(`${endpoint}/investimentos-${rubrica}/?propostaEmpresaProponenteId=${id}`);
    },

    buscarExecutora(id, rubrica) {
        return ApiService.get(`${endpoint}/investimentos-${rubrica}/?id=${id}`);
    },

    salvar(rubrica, formulario) {

        let form = cloneDeep(formulario);

        if(form.investimentosPropostasExecutoras){
            form.investimentosPropostasExecutoras = form.investimentosPropostasExecutoras.map(element => {
                element.valorAlocado = helpers.removerValor(element.valorAlocado);
                if(!element.totalPrevisto)
                    element.totalPrevisto = 0;
                return element;
            });
        }

        /*if(form.investimentosPropostasCooperadas)
        form.investimentosPropostasCooperadas.forEach(element => {
            element.valorAlocado = helpers.removerValor(element.valorAlocado);
        });*/

        if(form.investimentoPropostaCooperada){
            form.investimentoPropostaCooperada.valorAlocado = helpers.removerValor(form.investimentoPropostaCooperada.valorAlocado);
            if(!form.investimentoPropostaCooperada.totalPrevisto)
                form.investimentoPropostaCooperada.totalPrevisto = 0;
        }

        if(form.investimentoPropostaProponente){
            form.investimentoPropostaProponente.valorAlocado = helpers.removerValor(form.investimentoPropostaProponente.valorAlocado);
            if(!form.investimentoPropostaProponente.totalPrevisto)
                form.investimentoPropostaProponente.totalPrevisto = 0;
        }
        if(form.investimentoProposta){
            form.investimentoProposta.valorAlocado = helpers.removerValor(form.investimentoProposta.valorAlocado);
            if(!form.investimentoProposta.totalPrevisto)
                form.investimentoProposta.totalPrevisto = 0;
        }

        return ApiService.put(`${endpoint}/investimentos-${rubrica}`, form);
    }
}

export default Investimento;
